// extracted by mini-css-extract-plugin
export default {"tech-stack":"TechStack_tech-stack__ZeW7V","list":"TechStack_list__lfXxt","card":"TechStack_card__hEuIc"};